<div
  id="page-container"
  class="page-container fadeXX page-sidebar-fixed page-header-fixed body-custom"
>
  <app-header></app-header>

  <div id="content" class="content">
    <div class="section-container p-t-30 p-b-30">
      <div class="contenedorInstrucciones">
        <router-outlet />
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
